<template>
  <div class="tabview-main">
    <div class="tab-header-container">
      <div class="tab-header-item" v-for="(t, index) in tabs" :key="index" :style="{ width: `calc(100% / ${tabs.length})`,
        transformOrigin: index == 0 ? '0 100%' : index == tabs.length - 1 ? '100% 100%' : 'center bottom',
        transform: index == pActiveTab ? 'scale(1.1)' : 'scale(1)', zIndex: index == pActiveTab ? '1' : '0',
        fontWeight: index == pActiveTab ? 'bolder' : 'normal', borderWidth: index == pActiveTab ? '1px 1px 0 1px' : '1px',
        backgroundColor: t.enabled ? 'white' : 'gray', pointerEvents: t.enabled ? 'auto' : 'none' }"
        @click="tabClicked(index)">
        {{ t.title }}
      </div>
    </div>
    <div class="tab-content">
      <SupplierGeneral v-if="tabs[pActiveTab].component == 'SupplierGeneral'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <ContactDetails v-if="tabs[pActiveTab].component == 'ContactDetails'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <Attachments v-if="tabs[pActiveTab].component == 'Attachments'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <GSTDetails v-if="tabs[pActiveTab].component == 'GSTDetails'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <SupplierAgentDetails v-if="tabs[pActiveTab].component == 'SupplierAgentDetails'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <SupplierHaulierDetails v-if="tabs[pActiveTab].component == 'SupplierHaulierDetails'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <!-- Customer Profile -->
      <CustomerGeneral v-if="tabs[pActiveTab].component == 'CustomerGeneral'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <CustomerBilling v-if="tabs[pActiveTab].component == 'CustomerBilling'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <CustomerCredit v-if="tabs[pActiveTab].component == 'CustomerCredit'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <CustomerSalesService v-if="tabs[pActiveTab].component == 'CustomerSalesService'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />

      <CustomerGeneralV2 v-if="tabs[activeTab].component == 'CustomerGeneralV2'" :data="tabs[activeTab].data" :viewMode="viewMode" />
      <CustomerBillingV2 v-if="tabs[activeTab].component == 'CustomerBillingV2'" :data="tabs[activeTab].data" :viewMode="viewMode" />
      <CustomerCreditV2 v-if="tabs[activeTab].component == 'CustomerCreditV2'" :data="tabs[activeTab].data" :viewMode="viewMode" />
      <CustomerSalesServiceV2 v-if="tabs[activeTab].component == 'CustomerSalesServiceV2'" :data="tabs[activeTab].data" :viewMode="viewMode" />

      <!-- Freight Forwarding -->
      <FFROT v-if="tabs[pActiveTab].component == 'FreightROT'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <LocationInfo v-if="tabs[pActiveTab].component == 'LocationInfo'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <ContainerInfo v-if="tabs[pActiveTab].component == 'ContainerInfo'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <AttachmentsPage v-if="tabs[pActiveTab].component == 'AttachmentsPage'" :data="tabs[pActiveTab].data" />
      <!--Destination-->
      <DestinationLocationDetails v-if="tabs[pActiveTab].component == 'DestinationLocationDetails'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <DestinationGeneral v-if="tabs[pActiveTab].component == 'DestinationGeneral'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <!--Vehicle-->
      <VehicleGeneral v-if="tabs[pActiveTab].component == 'VehicleGeneral'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <VehicleEngineInformation v-if="tabs[pActiveTab].component == 'VehicleEngineInformation'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <VehicleRenewalInfo v-if="tabs[pActiveTab].component == 'VehicleRenewalInfo'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <VehicleMaintenance v-if="tabs[pActiveTab].component == 'VehicleMaintenance'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
      <VehicleTyreConfiguration v-if="tabs[pActiveTab].component == 'VehicleTyreConfiguration'" :data="tabs[pActiveTab].data" :viewMode="viewMode" />
    </div>

    <div :style="{ zIndex: pLoadingPage ? 99 : -99 }" class="tabview-loading">Loading {{ pLoadingName }} Tab</div>
  </div>
</template>

<script>
/* eslint-disable */
import SupplierGeneral from '@/components/tabComponents/SupplierGeneral.vue';
import ContactDetails from '@/components/tabComponents/ContactDetails.vue';
import Attachments from '@/components/tabComponents/Attachments.vue';
import GSTDetails from '@/components/tabComponents/GSTDetails.vue';
import SupplierAgentDetails from '@/components/tabComponents/SupplierAgentDetails.vue';
import SupplierHaulierDetails from '@/components/tabComponents/SupplierHaulierDetails.vue';

import CustomerGeneral from '@/components/tabComponents/CustomerProfile/CustomerGeneral.vue';
import CustomerBilling from '@/components/tabComponents/CustomerProfile/CustomerBilling.vue';
import CustomerCredit from '@/components/tabComponents/CustomerProfile/CustomerCredit.vue';
import CustomerSalesService from '@/components/tabComponents/CustomerProfile/CustomerSalesService.vue';

import CustomerGeneralV2 from '@/components/tabComponents/CustomerProfileV2/CustomerGeneral.vue';
import CustomerBillingV2 from '@/components/tabComponents/CustomerProfileV2/CustomerBilling.vue';
import CustomerCreditV2 from '@/components/tabComponents/CustomerProfileV2/CustomerCredit.vue';
import CustomerSalesServiceV2 from '@/components/tabComponents/CustomerProfileV2/CustomerSalesService.vue';

import FFROT from '@/components/tabComponents/FreightForwarding/ROT.vue';
import LocationInfo from '@/components/tabComponents/FreightForwarding/ROT/LocationInfoPage.vue';
import ContainerInfo from '@/components/tabComponents/FreightForwarding/ROT/ContainerInfoPage.vue';
import AttachmentsPage from '@/components/tabComponents/FreightForwarding/ROT/AttachmentsPage.vue';

import DestinationLocationDetails from '@/components/tabComponents/Destination/DestinationLocationDetails.vue';
import DestinationGeneral from '@/components/tabComponents/Destination/DestinationGeneral.vue';

import VehicleGeneral from '@/components/tabComponents/Vehicle/VehicleGeneral.vue';
import VehicleEngineInformation from '@/components/tabComponents/Vehicle/VehicleEngineInformation.vue';
import VehicleRenewalInfo from '@/components/tabComponents/Vehicle/VehicleRenewalInfo.vue';
import VehicleMaintenance from '@/components/tabComponents/Vehicle/VehicleMaintenance.vue';
import VehicleTyreConfiguration from '@/components/tabComponents/Vehicle/VehicleTyreConfiguration.vue';

export default { // OBSOLETE COMPONENT (Use Tab.vue instead)
  components: {
    // Supplier Components
    SupplierGeneral, ContactDetails, Attachments, GSTDetails, SupplierAgentDetails, SupplierHaulierDetails, 
    // Customer Profile
    CustomerGeneral, CustomerBilling, CustomerCredit, CustomerSalesService, 
    CustomerGeneralV2, CustomerBillingV2, CustomerCreditV2, CustomerSalesServiceV2,
    // FreightForwarding Components
    FFROT, LocationInfo, ContainerInfo, AttachmentsPage,
    // Destination Components
    DestinationLocationDetails, DestinationGeneral, 
    //Vehicle Components
    VehicleGeneral, VehicleEngineInformation, VehicleRenewalInfo, VehicleMaintenance, VehicleTyreConfiguration,
  },
  data: function() {
    return {
      pLoadingPage: false,
      pLoadingName: '',
      pActiveTab: 0
    }
  },
  props: {
    loadingPage: { type: Boolean, default: false },
    loadingName: { type: String, default: '' },
    
    // Public Properties
    tabs: { type: Array, default: function() { return [] } }, // The tabs item
    activeTab: { type: Number, default: 0 }, // Which tab is active (First tab is 0)
    viewMode: { type: Boolean, default: false },

    // Public Events
    // @tabChanged - fires when the tab is changed, returns the tab index
  },
  methods: {
    tabClicked: function(index) {
      this.pLoadingPage = true;
      this.$emit('update:loadingPage', this.pLoadingPage);
      this.pLoadingName = this.tabs[index].title;
      this.$emit('update:loadingName', this.pLoadingName);

      setTimeout(() => {
        this.pActiveTab = index;
        this.$emit('update:activeTab', index);

        this.$nextTick(() => {
          this.pLoadingPage = false;
          this.$emit('update:loadingPage', this.pLoadingPage);
          this.$emit('tabChanged', this.pActiveTab);
          this.pLoadingName = '';
          this.$emit('update:loadingName', this.pLoadingName);
        });
      }, 10);
    }
  },
  mounted() {
    if (this.activeTab) {
      this.pActiveTab = this.activeTab;
    }
  },
  watch: {
    tabs: {
      deep: true,
      handler(val) {
        var disabled = val.filter((v) => { return !v.enabled });
        var enabled = val.filter((v) => { return v.enabled });

        disabled.forEach((d) => {
          if (val.indexOf(d) == this.pActiveTab) {
            this.pActiveTab = val.indexOf(enabled[enabled.length - 1]);
            this.$emit('update:activeTab', this.pActiveTab);
            this.$emit('tabChanged', this.pActiveTab);
          }
        });
      }
    },
    activeTab: function(val) {
      this.pActiveTab = val;
      this.tabClicked(val);
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
$borderColor: rgba(128,128,128,0.75);

.tabview-main {
  height: 100%;
  width: 100%;
  position: relative;

  > .tab-header-container {
    display: flex;
    height: 30px;

    > .tab-header-item {
      background-color: white;
      border-width: 1px;
      border-style: solid;
      border-color: $borderColor;
      text-align: center;
      padding: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      cursor: pointer;
    }
  }

  > .tab-content {
    height: fit-content;
    border-width: 0 1px 1px 1px;
    border-style: solid;
    border-color: $borderColor;
    padding: 5px;
    margin-bottom: 5px;

    > .content-row {
      display: flex;

      > .content-details {
        padding: 0 5px;
      }
    }
  }
}

.tabview-loading {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.3);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bolder;
  font-size: 1.5em;
}
</style>